import { gql } from '@/__generated__';

const TRIGGER_MASSIVE_DGA_RETRY = gql(`#graphql
  mutation TriggerRetryForAllDevices {
    triggerRetryForAllDevices {
      success
    }
  }
`);

export default TRIGGER_MASSIVE_DGA_RETRY;
